import Login from 'containers/Matricula/Login'

export default function LoginPage() {
  return (
    <Login />
  );
}
